import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom"; // Import useLocation
// Common
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

// Auth
import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";

// Public
import Home from "./components/public/Home"; // Import Home for visitors

// User Panel
import Sidebar from "./components/user/Sidebar";
import Dashboard from "./components/user/Dashboard";
import Users from "./components/user/Users";
// import Events from "./components/user/Events";
// import EventDetail from "./components/user/EventDetail";
// import EventForm from "./components/user/EventForm";
// import Moderate from "./components/user/Moderate";
// import Ads from "./components/user/Ads";
// import AdsGroup from "./components/user/AdsGroup";
// import Scripts from "./components/user/Scripts";
// import Students from "./components/user/Students";
// import FeesManagement from "./components/user/FeesManagement";
// import UploadVideo from "./components/user/uploadMedia.js";
// import UploadNotification from "./components/user/Notifications";
// import OnlineTest from "./components/user/OnlineTest";
// import QuestionPaper from "./components/user/QuestionPaper";
// import AddSubject from "./components/user/AddSubject";
// import DonationSumarry from "./components/user/DonationSummaryTab.js";
// import UserDetails from "./components/user/UserDetails.js";
import AccountSettings from "./components/user/AccountSettings";
import "./App.css";
import DonorGroup from "./components/user/DonorGroup.js";
import Donor from "./components/user/Donor.js";
import Conversation from "./components/user/Conversation.js";
import Gifts from "./components/user/Gifts.js";
// import SbiDonations from "./components/user/Donations.js";
import Donations from "./components/user/Donations.js";
import RecurringDonation from "./components/user/RecurringDonation.js";
import PhonePeTransactions from "./components/user/PhonePeTransactions.js";
import OtherSetting from "./components/user/OtherSetting.js";
import Aarti from "./components/user/Aarti.js";
import Courses from "./components/user/Courses.js";
import ManualRecurringDonation from "./components/user/ManualRecurringDonation.js";
import ManualRecurringDonationSummary from "./components/user/ManualRecurringDonationSummary.js";
import Leads from "./components/user/Leads.js";
import useFetchMasterData from "./hooks/useFetchMasterData.js";
import OneTimeDonationTab from "./components/user/OneTimeDonationLeadTab.js";
import UploadHistory from "./components/user/UploadHistory.js";
import TRNumber from "./components/user/TRNumber.js";
import UserConfirmation from "./components/user/UserConfirmation.js";
import ForgotPassword from "./components/user/ForgotPassword.js";
import UserJoin from "./components/user/JoinUser.js";
import Master from "./components/user/Master.js";
import GiftDistribution from "./components/user/GiftDistribution.js";
import EventManagement from "./components/user/EventManagement.js";
import DailyQuotes from "./components/user/DailyQuotes.js";
import DailyDarshan from "./components/user/DailyDarshan.js";
import TempleProgramSchedule from "./components/user/TempleProgramSchedule.js";
import DailyRegistrations from "./components/user/DailyRegistrations.js";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(""); // State to store user role
  const location = useLocation(); // Now works correctly inside Router context

  useFetchMasterData();

  useEffect(() => {
    const accessTokenCheck = localStorage.getItem("accessToken");
    if (accessTokenCheck) {
      setIsLoggedIn(true);
    }
  }, []);

  // Determine if the current route is "event/:eventUrlSlug"
  const userConfirmationPage =
    location.pathname.startsWith("/user/confirmation");
  const isEventFormPage = location.pathname.startsWith("/event-form/");

  // console.log({userConfirmationPage});

  return (
    <div className="App wrapper">
      {/* Conditionally render Sidebar based on login and role */}

      {isLoggedIn &&
        !userConfirmationPage && // Exclude Sidebar on EventDetail page
        !isEventFormPage && <Sidebar />}

      <div
        className={
          isLoggedIn && !userConfirmationPage && !isEventFormPage
            ? "main-panel"
            : ""
        }
      >
        {/* Conditionally render Header */}
        {isLoggedIn && !userConfirmationPage && !isEventFormPage && <Header />}

        {/* Routes */}
        <Routes>
          {/* Landing page for visitors */}
          <Route
            path="/"
            element={
              isLoggedIn ? <Navigate to={"/user/dashboard"} /> : <Home />
            }
          />
          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />

          <Route path="/logout" element={<Logout />} />

          {/* User routes only allowed for admin if role is admin otherwise redirect to current route */}
          <Route
            path="/user/dashboard"
            element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />}
          />

          <Route
            path="/user/users"
            element={
              isLoggedIn ? (
                <Users />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add Donor ROutes */}
          <Route
            path="/donor"
            element={
              isLoggedIn ? (
                <Donor />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add Conversation ROutes */}
          <Route
            path="/donor/conversation"
            element={
              isLoggedIn ? (
                <Conversation />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a donor group route */}
          <Route
            path="/donor/group"
            element={
              isLoggedIn ? (
                <DonorGroup />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a Gift route */}
          <Route
            path="/user/gifts"
            element={
              isLoggedIn ? (
                <Gifts />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Gift Distrbution route */}
          <Route
            path="/user/gifts/distribution"
            element={
              isLoggedIn ? (
                <GiftDistribution />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Parent route */}
          <Route
            path="/user/manual-recurring-donation"
            element={
              isLoggedIn ? (
                <ManualRecurringDonation />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Manual Recurring  route */}
          <Route
            path="/user/manual-recurring-donation-summary"
            element={
              isLoggedIn ? (
                <ManualRecurringDonationSummary />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Leads  route */}
          <Route
            path="/user/leads"
            element={
              isLoggedIn ? (
                <Leads />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Sbi Donation Route */}
          <Route
            path="/donations"
            element={
              isLoggedIn ? (
                <Donations />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          {/* Add a recurring Donation Route */}
          <Route
            path="/recurring/donations"
            element={
              isLoggedIn ? (
                <RecurringDonation />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a One Time Leads  */}
          <Route
            path="/user/one-time-donation-leads"
            element={
              isLoggedIn ? (
                <OneTimeDonationTab />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a One Time Leads  */}
          <Route
            path="/user/phonepe-transactions"
            element={
              isLoggedIn ? (
                <PhonePeTransactions />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a upload historyRoute  */}
          <Route
            path="/upload/history"
            element={
              isLoggedIn ? (
                <UploadHistory />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a Tr Number Route  */}
          <Route
            path="/tr-manager"
            element={
              isLoggedIn ? (
                <TRNumber />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a user join table route */}

          <Route
            path="/user/joined"
            element={
              isLoggedIn ? (
                <UserJoin />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/account-settings"
            element={
              isLoggedIn ? (
                <AccountSettings />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/other-settings"
            element={
              isLoggedIn ? (
                <OtherSetting />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/confirmation"
            element={
              isLoggedIn ? (
                <UserConfirmation />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          {/* Add a password forgot PasswordRoute  */}
          <Route
            path="/user/forgot-password"
            element={
              !isLoggedIn ? (
                <ForgotPassword />
              ) : (
                (() => {
                  localStorage.setItem("redirectTo", location.pathname);
                  return <Navigate to="/user/dashboard" />;
                })()
              )
            }
          />

          <Route
            path="/user/aarti"
            element={
              isLoggedIn ? (
                <Aarti />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />
          <Route
            path="/user/courses"
            element={
              isLoggedIn ? (
                <Courses />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/master"
            element={
              isLoggedIn ? (
                <Master />
              ) : (
                // Store the current route in localStorage before redirecting
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/events"
            element={
              isLoggedIn ? (
                <EventManagement />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/daily-darshan"
            element={
              isLoggedIn ? (
                <DailyDarshan />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/temple-program-schedule"
            element={
              isLoggedIn ? (
                <TempleProgramSchedule />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/daily-quotes"
            element={
              isLoggedIn ? (
                <DailyQuotes />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route
            path="/user/daily-registrations"
            element={
              isLoggedIn ? (
                <DailyRegistrations />
              ) : (
                localStorage.setItem("redirectTo", location.pathname) && (
                  <Navigate to="/login" />
                )
              )
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Conditionally render Footer */}
        {isLoggedIn && !userConfirmationPage && !isEventFormPage && <Footer />}
      </div>
    </div>
  );
}

export default App;
